import {
  type ICustomerProductDetail,
  type ILanguageType,
} from '@mahawi/eshop-common/src/types';
import { createSlice } from '@reduxjs/toolkit';

import {
  asyncStateInitial,
  finishLoading,
  requestFailedMatcher,
  resetLoadingOnRequestFailed,
  startLoading,
} from '../async-state';
import { type ISearchState } from './types';

export const preloadedState: ISearchState = {
  ...asyncStateInitial,
  query: undefined,
  products: undefined,
};

const searchSlice = createSlice({
  name: 'Search',
  initialState: preloadedState,
  reducers: {
    search: {
      reducer(
        state,
        action: { payload: { query: string; languageType: ILanguageType } },
      ) {
        startLoading(state);
        state.products = undefined;
        state.query = action.payload.query;
      },
      prepare(query: string, languageType: ILanguageType) {
        return { payload: { query, languageType } };
      },
    },
    searchResponse: {
      reducer(
        state,
        action: {
          payload: { query: string; products: ICustomerProductDetail[] };
        },
      ) {
        if (action.payload.query !== state.query) {
          return;
        }
        state.products = action.payload.products;
        finishLoading(state);
      },
      prepare(query: string, products: ICustomerProductDetail[]) {
        return { payload: { query, products } };
      },
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      requestFailedMatcher('Search'),
      resetLoadingOnRequestFailed,
    );
  },
});

export const { search, searchResponse } = searchSlice.actions;
export default searchSlice.reducer;
